import { createSelector } from 'reselect';
import { filter } from 'ramda';
import { getFormValues } from 'redux-form';

import { filterByString } from '@topconagriculture/frontend-utils';

import { Forms } from '../../form/form.selector';
import { RootState } from '../../reducers';
import { CodeElement, CodeTypeNames } from '../code/code.types';
import { getCodeListFilteredByType } from '../code/code.selector';
import { LotType } from './lotTypes.types';

export const getLotTypes = (state: RootState): LotType[] => state.entities.lotTypes;

export const getLotTypeById = createSelector([getLotTypes], (lotTypes: LotType[]) => (id: string) => {
  return lotTypes.find((lotType) => lotType.id === id);
});

const getLotTypeClasses = (state: RootState): CodeElement[] =>
  getCodeListFilteredByType(state, { codeType: CodeTypeNames.lotClassCodes });

export const getLotTypesListFilteredBySearch = createSelector(
  [getLotTypes, getFormValues(Forms.lotTypesSearchForm)],
  (lotTypesList, filterForm: any): LotType[] =>
    filterForm && filterForm.search
      ? filter((groupType) => filterByString(groupType.description, filterForm.search), lotTypesList)
      : lotTypesList,
);

export const getLotTypeDescriptionByCode = createSelector(
  [getLotTypeClasses, (state: RootState, code: number) => code],
  (lotTypeClasses, code): string | undefined => {
    const lotTypeClass = lotTypeClasses.find((el) => el.code === code);
    return lotTypeClass ? lotTypeClass.description1 : undefined;
  },
);
